module.exports = __webpack_public_path__ + "img/Multi-account-en-4.d3ab07b5.png";